export const BLOG_ITEMS_PER_PAGE = 15;

export const PAGINATION_INNER_LIMIT = 2;
export const PAGINATION_OUTER_LIMIT = 2;
export const PAGINATION_INNER_LIMIT_MOBILE = 1;
export const PAGINATION_OUTER_LIMIT_MOBILE = 1;
